/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import {pxToEm, replacePXinStringWithEM, themeV2} from '@insticator/insticator-ui';
import {hoverTransition, aniSpeed} from '../../../utils/styles/general';


/* ++++++++++ --------------- SIDEBAR : STYLES --------------- ++++++++++ */
export default {
    sidebar: {
        boxShadow: replacePXinStringWithEM(`0px 0px 24px 0px rgba(172, 217, 251, 0.2)`),
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        position: 'relative',
        zIndex: '3',
        extend: hoverTransition('box-shadow'),
        opacity: '0',
        animationName: 'fadeInLeft',
        animationDuration: aniSpeed,
        animationFillMode: 'forwards',
        '&:hover': {
            boxShadow: replacePXinStringWithEM(`0px 0px 24px 0px rgba(172, 217, 251, 0.5)`),
        },
        // temporary styling to imitate dropdown look, until replaced with functional dropdown
        '& .filter-company': {
            cursor: 'default',
            border: `1px solid ${themeV2.color.base.gray.light}`,
            borderRadius: pxToEm(12),
            width: '90%',
            maxWidth: pxToEm(260),
            // margin: '1em'
            padding: '0.5em 1em',
            whiteSpace: 'nowrap',
            '& .name': {
                fontSize: pxToEm(14),
                height: pxToEm(16),
                color: themeV2.color.base.gray.secondary,
                fontWeight: 500,
            },
            '& .title': {
                fontSize: pxToEm(16),
                fontWeight: 500,
                color: themeV2.color.primary.main,
                height: '24px',
                paddingTop: '4px',
                whiteSpace: 'nowrap',
                overflow: 'hidden',
                textOverflow: 'ellipsis'
            },
            '&.sidebarOpen': {
                '&-false': {
                   display: 'none'
                }
            }
        },
        '&.sidebarOpen': {
            '&-true': {
                flex: `0 0 ${pxToEm(260)}`,
                // width: pxToEm(252)
            },
            '&-false': {
                flex: `0 0 ${pxToEm(88)}`,
                // width: pxToEm(88)
            }
        }
    }
};
